import React from 'react';
import styled from 'styled-components';
//importing data
import workData from '../../data/ourWorkData'
import Work from './Work';

const OurWork = () => {
    return (
        <Container>
            <div className="heading">
                <span>Our Works</span>
                <h4>Always Working with Dedication And Determination</h4>
            </div>
            <div className="elements">
                {
                    workData.map(data => (
                        <Work
                            data={data}
                        />
                    ))
                }
            </div>
        </Container>
    )
}

export default OurWork


const Container = styled.div`
    background: #fff;
    margin-top: 5rem;
    padding-bottom: 3rem;
    .heading{
        text-align: center;
        padding: 0rem 10rem;
        padding-bottom: 1rem;
        span{
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
        color: #e21f36;
        }
        h4{
            color: #000219;
            font-size: 2rem;
            font-weight: 800;
        }
        p{
            color: #000219;
            font-size: 1.2rem;
        }
        @media screen and (max-width: 900px){
            padding: 0rem 1rem;
            /* h4{
                font-size: 1rem;
            } */
        }
    }
    .elements{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        /* margin: 0rem 5rem; */
        @media screen and (min-width: 800px){
            /* padding: 0rem 1rem !important; */
        }
    }
`